import { createFileRoute } from '@tanstack/react-router'
import { useGoBack } from '@/hooks/use-go-back'
import { Button } from '@/components/ui/button'
import { ArrowLeft } from 'lucide-react'
import { NewsForm } from '@/features/news/components/news-form'
import { useRequireAdmin } from '@/features/auth'
import { Spinner } from '@/components/ui/spinner'

export const Route = createFileRoute('/_authenticated/news/new')({
  component: RouteComponent,
})

function RouteComponent() {
  const goBack = useGoBack()
  const { canAccess, isLoading } = useRequireAdmin('/news')

  if (isLoading) {
    return (
      <div className="flex h-64 items-center justify-center">
        <Spinner className="size-8" />
      </div>
    )
  }
  if (!canAccess) return null

  return (
    <div className="flex flex-col gap-4 p-4">
      <div className="flex items-center gap-2">
        <Button variant="ghost" size="icon" className="cursor-pointer" onClick={() => goBack({ to: '/news' })}>
          <ArrowLeft className="h-4 w-4" />
        </Button>
        <h1 className="text-xl font-semibold">Nuova News</h1>
      </div>
      <NewsForm />
    </div>
  )
}
